
/**
 * 
 * @export
 * @interface VyzvaPublicDynamickaSekcia
 */
export interface VyzvaPublicDynamickaSekcia {
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDynamickaSekcia
     */
    'casZneplatnenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDynamickaSekcia
     */
    'dynamickaSekciaKod'?: VyzvaPublicDynamickaSekciaDynamickaSekciaKodEnum;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDynamickaSekcia
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDynamickaSekcia
     */
    'value'?: string;
    /**
     * 
     * @type {number}
     * @memberof VyzvaPublicDynamickaSekcia
     */
    'verziaZaznamu'?: number;
}

export const VyzvaPublicDynamickaSekciaDynamickaSekciaKodEnum = {
    Specprostriedkov: 'VYZVA_DS_SPECPROSTRIEDKOV',
    Specvydavkov: 'VYZVA_DS_SPECVYDAVKOV',
    Dalsieinformacie: 'VYZVA_DS_DALSIEINFORMACIE'
} as const;

export type VyzvaPublicDynamickaSekciaDynamickaSekciaKodEnum = typeof VyzvaPublicDynamickaSekciaDynamickaSekciaKodEnum[keyof typeof VyzvaPublicDynamickaSekciaDynamickaSekciaKodEnum];


